import { render, staticRenderFns } from "./ForgetPw.vue?vue&type=template&id=03fc1876"
import script from "./ForgetPw.vue?vue&type=script&lang=js"
export * from "./ForgetPw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports